import { render, staticRenderFns } from "./CreateVehicleDialog.vue?vue&type=template&id=4a5450a7&scoped=true"
import script from "./CreateVehicleDialog.vue?vue&type=script&lang=ts"
export * from "./CreateVehicleDialog.vue?vue&type=script&lang=ts"
import style0 from "./CreateVehicleDialog.vue?vue&type=style&index=0&id=4a5450a7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a5450a7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VStepper } from 'vuetify/lib/components/VStepper';
import { VStepperContent } from 'vuetify/lib/components/VStepper';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAutocomplete,VCardText,VForm,VIcon,VListItem,VListItemContent,VListItemTitle,VStepper,VStepperContent,VTextField})
